import { render, staticRenderFns } from "./UploadMultiple.vue?vue&type=template&id=3cdfd8e3&scoped=true&"
import script from "./UploadMultiple.vue?vue&type=script&lang=js&"
export * from "./UploadMultiple.vue?vue&type=script&lang=js&"
import style0 from "./UploadMultiple.vue?vue&type=style&index=0&id=3cdfd8e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdfd8e3",
  null
  
)

export default component.exports